module.exports = __webpack_public_path__ + "static/Ian-7ca3a26d0fc702028dd0dffea1211686.jpeg";